var map = {
	"./chantelle/noticeshout/allbetslocked.mp3": 1715,
	"./chantelle/noticeshout/betbeforespinning.mp3": 8842,
	"./chantelle/noticeshout/lockinyourbets.mp3": 577,
	"./jack/noticeshout/allbetslocked.mp3": 110,
	"./jack/noticeshout/betbeforespinning.mp3": 4691,
	"./jack/noticeshout/lockinyourbets.mp3": 2654,
	"./mae/noticeshout/allbetslocked.mp3": 5390,
	"./mae/noticeshout/betbeforespinning.mp3": 4163,
	"./mae/noticeshout/lockinyourbets.mp3": 4014,
	"./trina/noticeshout/allbetslocked.mp3": 9977,
	"./trina/noticeshout/betbeforespinning.mp3": 4172,
	"./trina/noticeshout/lockinyourbets.mp3": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1405;